module.exports = __webpack_public_path__ + "img/ID.8f5da81e.svg";